import { css, sva } from '@portal/styled-system/css'

// These layers are ordered inside landingBackgroundContainer,
// which creates stacking context via isolation.
const backgroundLayerZIndex = {
    video: 1,
    decoration: 2,
    character: 3,
} as const

export const homePageRecipe = sva({
    slots: [
        'pageContainer',
        'landingBackgroundContainer',
        'taongaBackgroundVideo',
        'imageLeft',
        'imageBottomRight',
        'pageContent',
        'landingLogo',
        'authFormContainer',
    ],
    base: {
        pageContainer: {
            position: 'relative',
            minHeight: 'screen',
            height: 'screen',
            animationStyle: 'fade-in',
        },
        landingBackgroundContainer: {
            isolation: 'isolate',
        },
        taongaBackgroundVideo: {
            objectFit: 'cover',
            width: 'full',
            height: 'full',
            position: 'fixed',
            top: '0',
            left: '0',
            zIndex: backgroundLayerZIndex.video,
        },
        imageLeft: {
            objectFit: 'cover',
            position: 'fixed',
            top: '0',
            left: '0',
            height: 'full',
            zIndex: backgroundLayerZIndex.decoration,
            '@media only screen and (max-width: 1080px)': {
                maxWidth: 'full',
            },
        },
        imageBottomRight: {
            position: 'fixed',
            right: '0',
            maxHeight: '[25%]',
            display: 'none',
            bottom: '0',
            zIndex: backgroundLayerZIndex.decoration,
            '@media screen and (min-width: 576px)': {
                display: 'block',
            },
            '@media screen and (min-width: 992px)': {
                bottom: '[var(--min-footer-height)]',
            },
        },
        pageContent: {
            paddingTop: '[32px]',
            paddingBottom: '[var(--min-footer-height)]',
            '@media only screen and (max-height: 770px)': {
                paddingTop: '[12vh]',
            },
            '@media only screen and (max-height: 650px)': {
                paddingTop: '[10vh]',
            },
            '@media only screen and (max-height: 600px)': {
                paddingTop: '[32px]',
            },
        },
        landingLogo: {
            position: 'relative',
            display: 'block',
            marginTop: '[2%]',
            marginRight: 'auto',
            marginBottom: '0',
            marginLeft: 'auto',
            objectFit: 'contain',
            '@media only screen and (max-height: 840px)': {
                marginTop: '[20px]',
                height: '[20vh]',
            },
            '@media only screen and (max-height: 770px)': {
                display: 'none',
            },
            '@media only screen and (max-width: 512px)': {
                width: 'full',
            },
        },
        authFormContainer: {
            display: 'flex',
            justifyContent: 'center',
            marginY: '2',
        },
    },
})

export const imageCharacterClassName = css({
    position: 'fixed',
    left: '0',
    maxHeight: '[80%]',
    display: 'none',
    bottom: '0',
    zIndex: backgroundLayerZIndex.character,
    '@media screen and (min-width: 576px)': {
        display: 'block',
    },
    '@media screen and (min-width: 992px)': {
        bottom: '[var(--min-footer-height)]',
    },
    '@media screen and (max-width: 1068px)': {
        display: 'none',
    },
    '@media screen and (max-width: 1200px)': {
        left: '[-100px]',
    },
})
